import { PriceStampType } from '@terminal/components/price-display-view/helpers/price-display-helpers';
import { format, toZonedTime } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';

import styles from './PriceCellTooltip.module.scss';
import { getMarketSessionLabelKey, getTimezoneAbbreviation } from './utils';

export const PriceCellTooltip = ({
  type,
  date,
}: {
  type: PriceStampType;
  date: string;
}) => {
  const { t } = useTranslation(['watchlistManager']);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = getTimezoneAbbreviation(date);

  const lastTradeDate = format(
    date,
    `h:mm:ss a '${timezoneAbbr}' MMMM d, yyyy`,
    {
      timeZone: userTimezone,
    }
  );

  const asOfCloseDate = format(date, `MMMM d, yyyy '${timezoneAbbr}'`, {
    timeZone: userTimezone,
  });

  const zonedDate = toZonedTime(date, 'UTC');
  const lastCloseDate = format(zonedDate, `MMMM d, yyyy '${timezoneAbbr}'`, {
    timeZone: userTimezone,
  });

  const getContent = () => {
    switch (type) {
      case 'live':
        return (
          <>
            <span className={styles.timeLabel}>
              {t('watchlistManager:priceCell.asOfDate', {
                date: lastTradeDate,
              })}
            </span>
            <div className={styles.marketOpenWrapper}>
              <span className={styles.marketOpenLabel}>
                {t(getMarketSessionLabelKey())}
              </span>
              <span>·</span>
              <span className={styles.liveDataLabel}>
                {t('watchlistManager:priceCell.liveData')}
              </span>
            </div>
          </>
        );
      default:
        const dateToUse = type === 'notLive' ? asOfCloseDate : lastCloseDate;
        return (
          <>
            <span className={styles.timeLabel}>{dateToUse}</span>
            <span className={styles.asOfLastCloseLabel}>
              {t('watchlistManager:priceCell.asOfLastClose')}
            </span>
          </>
        );
    }
  };

  return <div className={styles.root}>{getContent()}</div>;
};
